var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterSectionInstagramBgBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 1.33337H4.66658C2.82564 1.33337 1.33325 2.82576 1.33325 4.66671V11.3334C1.33325 13.1743 2.82564 14.6667 4.66658 14.6667H11.3333C13.1742 14.6667 14.6666 13.1743 14.6666 11.3334V4.66671C14.6666 2.82576 13.1742 1.33337 11.3333 1.33337Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 7.58008C10.7488 8.13491 10.6541 8.70156 10.3957 9.19942C10.1374 9.69729 9.72865 10.101 9.22764 10.3532C8.72662 10.6054 8.15885 10.6931 7.60508 10.604C7.0513 10.5149 6.53973 10.2535 6.14311 9.85685C5.7465 9.46024 5.48504 8.94866 5.39593 8.39489C5.30682 7.84111 5.3946 7.27334 5.64677 6.77233C5.89894 6.27131 6.30268 5.86257 6.80054 5.60424C7.29841 5.34591 7.86506 5.25114 8.41989 5.33341C8.98583 5.41734 9.50979 5.68105 9.91435 6.08562C10.3189 6.49018 10.5826 7.01413 10.6666 7.58008Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 4.33337H11.674",
    stroke: "#1D1D1D",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSectionInstagramBgBlack);
export default __webpack_public_path__ + "static/media/footer_section_instagram_bg_black.e9a3b90d1c6ccc0fd2477892640b00ca.svg";
export { ForwardRef as ReactComponent };